import React, { useContext } from 'react';
import styles from './TextFlexRow1.module.css'

const TextFlexRow1 = (props) => {
    const title = props.title;
    const subtitle = props.subtitle;
    const text = props.text;

    return (
        <div className={styles.layout}>
            <div className={styles.content_container}>
                <div className={styles.content}>

                    <span className={styles.title}><b>{title}</b></span> {/* TITLE */}
                    <span className={styles.subtitle}><b>{subtitle}</b></span> {/* SUB-TITLE */}

                    <div className={styles.content_text} dangerouslySetInnerHTML={{ __html: text }}>{/* BODY TEXT */}</div>

                </div>
            </div>
        </div>
    )
};

export default TextFlexRow1;
